import React from 'react';
import { motion } from 'framer-motion';
import './index.scss';
import DefaultCustomQuoteIcon from '../../assets/images/custom-quote.png';
import {
  quoteVariants,
  quoteIconVariants,
  textVariants,
} from '../../assets/framer/styles';

const CustomQuote = ({
  quote,
  reference,
  iconSrc = DefaultCustomQuoteIcon,
  iconAlt = 'custom-quote',
}) => {
  return (
    <motion.div
      className="custom-quote"
      variants={quoteVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
    >
      <motion.img
        className="custom-quote-icon"
        src={iconSrc}
        alt={iconAlt}
        variants={quoteIconVariants}
      />
      <motion.p
        className="quote-text"
        variants={textVariants}
      >
        {quote}
      </motion.p>
      <motion.p
        className="quote-source"
        variants={textVariants}
      >
        {reference}
      </motion.p>
    </motion.div>
  );
};

export default CustomQuote;
